<script>
import * as am5 from "@amcharts/amcharts5";
import * as am5flow from "@amcharts/amcharts5/flow";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as moment from "moment";
import Layout from "../../layouts/main";
import DatePicker from "vue2-datepicker";
import Multiselect from 'vue-multiselect';

import { FETCH_RECON_SUMMARY, FETCH_RECON_SUMMARY_TABLE_RECORDS, DOWNLOAD_RECON_SUMMARY_TABLE_RECORDS, FETCH_CHANNEL_LIST, FETCH_USER_DATA_BY_PROPERTY_TYPE, FETCH_USER_DATA_BY_PROPERTY_TYPE_LIST, SEND_RECON_SUMERY_DATA_ON_EMAIL } from "@/state/actions.type";
import cloneDeep from 'lodash.clonedeep';
import DownloadBtn from '../../../components/download-btn.vue';
import Country from '../../../components/country.vue';
import PerPage from '../../../components/per-page.vue';
import Currency from "../../../components/currency.vue";
import Common from "../../../helpers/Common";

export default {
    components: {
        Layout,
        DatePicker,
        Multiselect,
        DownloadBtn,
        Country,
        PerPage,
        Currency
    },

    data() {
        return {
            fields: [
                { key: 'record_created_at', label: 'Created At', sortable: true },
                { key: 'transaction_id', label: 'Order Number', sortable: false, tdClass: "text-chai" },
                { key: 'sku_id', label: 'SKU Id', sortable: false },
                { key: 'amount', label: 'Amount', sortable: true },
                // { key: 'RecordType', label: 'Type', sortable: true },
                { key: 'marketplace_id', label: 'Marketplace', sortable: false },
                { key: 'raw_status', label: 'Order Status(DS1)', sortable: false },
                { key: 'raw_status_b', label: 'Order Status(DS2)', thClass: 'd-none', tdClass: 'd-none', sortable: false },
                { key: 'status', label: 'Reconciliation Status', thClass: 'd-none', tdClass: 'd-none', sortable: false },
                { key: 'source_display_name', label: 'Data Source', thClass: 'd-none', tdClass: 'd-none', sortable: false },
                { key: 'tags', label: 'Tags', sortable: true },
                { key: 'amount_mismatch', label: 'Amount Mismatch', sortable: true },
                { key: 'fee_mismatch', label: 'Fee Mismatch', sortable: true },
                { key: 'tax_mismatch', label: 'Tax Mismatch', sortable: true },
                { key: 'quantity', label: 'Quantity', sortable: true },
                { key: 'quantity_mismatch', label: 'Quantity Mismatch', sortable: true },
            ],
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            currentPage: 1,
            dataSourceA: null,
            dataSourceB: null,
            country: null,
            currency: null,
            series: null,
            loadingSankey: true,
            loadingTable: false,
            selectedNodes: [],
            selectedNodeNames: [],
            status: "reconciled",
            column_category: "transaction",
            mismatch_filter: {
                "transaction": [],
                "refund": []
            },
            selectedDates: [new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), new Date()],
            parameterType: "Amount",
            transactionType: "Payment",
            marketPlaceList: [],
            brandList: [],
            brand: [],
            marketPlace: [],
            countries: [],
            currencies: [],
            pageCurrency: null,
            hidePagination: false,
            downloading: false,
            filters: {
                country: null,
                currency: null,
                brand: [],
                marketPlace: [],
            }
        };
    },

    filters: {
        date(value) {
            return moment(value).format("DD MMM YYYY");
        },
        time(value) {
            return moment(value).format("hh:mm A");
        },
    },

    computed: {
        paymentChannelList() {
            return this.$store.state.reconciliation.paymentChannelList.selection;
        },
        paymentChannelListMap() {
            return this.$store.state.reconciliation.paymentChannelList.map;
        },

        reconSummary() {
            return this.$store.getters["reconAnalytics/reconSummary"];
        },

        tableDataFromStore() {
            return this.$store.getters["reconAnalytics/reconSummaryTable"];
        },
        additionalColumns() {
            return this.$store.getters["reconAnalytics/reconAdditionalColumns"];
        },
        tableColumns() {
            let columns = cloneDeep(this.fields);

            if(this.additionalColumns) {
                this.additionalColumns.map((el) => {
                    el.label = el.display_name;
                    el.col_key = el.key;
                    el.key = `${el.parent_key}.${el.key}`;
                    columns.push(el);
                })
            }

            return columns;
        },
        totalElementsFromStore() {
            return this.$store.getters["reconAnalytics/totalElements"];
        },

        tableTitle() {
            if(this.selectedNodeNames.length > 0) {
                return this.selectedNodeNames.join(" + ");
            }
            // if(this.dataSourceA && this.paymentChannelListMap[this.dataSourceA.key].category === 'MARKETPLACE') {
            //     return "Reconciled Orders";
            // }
            return this.reconSummary.dataFields[0].name;
            // return "Reconciled Transactions";
        },
        userPermissions() {
            return this.$store.getters["auth/getUserPermissionsList"];
        },
        userRoles() {
            return this.$store.getters['auth/getUserRolesList'];
        },
        filtersCount() {
            let c = 0;
            if(this.marketPlace.length > 0) {
                c++;
            }
            if(this.brand.length > 0) {
                c++;
            }
            if(this.country) {
                c++;
            }
            if(this.currency) {
                c++;
            }
            return c;
        }
    },

    created() {
        let dates = localStorage.getItem('recon_dashboard_dates');
        if(dates) {
            dates = JSON.parse(dates)
            if(dates.fromDate) {
                this.selectedDates[0] = new Date(dates.fromDate);
            }
            if(dates.toDate) {
                this.selectedDates[1] = new Date(dates.toDate);
            }
        }

        // this.$store.dispatch(`reconciliation/${FETCH_USER_DATA_BY_PROPERTY_TYPE}`,{
        //     property_type: 'country'
        // }).then((response) => {
        //     if(response.content) {
        //         this.countries = response.content.map(i => i['data_id']);

        //         if(this.countries.length > 0) {
        //             this.country = this.countries[0];
        //             this.filters.country = this.countries[0];
        //             this.pageCurrency = Common.currencyByCountry(this.countries[0]);
        //         }

                // API call removed
        //     }
        // });


        this.$store.dispatch(`reconciliation/${FETCH_CHANNEL_LIST}`).then(() => {
            let dataSources = this.dataSources();
            if(dataSources.length > 0) {
                let source_a = dataSources[0];
                if(this.$route.query.source_a) {
                    source_a = dataSources.find(el => el.key === this.$route.query.source_a);
                }
                this.dataSourceA = source_a;
                let dataSources2 = this.dataSources2();
                if(dataSources2.length > 0) {
                    let source_b = dataSources2[0];
                    if(this.$route.query.source_b) {
                        source_b = dataSources2.find(el => el.key === this.$route.query.source_b);
                    }

                    // let dateArr = [...this.selectedDates];
                    // if(!source_b.min_date.startsWith('0')) {
                    //     dateArr[0] = new Date(source_b.min_date);
                    // }
                    // if(!source_b.max_date.startsWith('0')) {
                    //     dateArr[1] = new Date(source_b.max_date);
                    // }
                    // this.selectedDates = dateArr;

                    this.dataSourceB = source_b;
                }

                this.setColumnsByPSPType();
            }
        }).catch((error) => {
            console.log(error);
            this.loadingSankey = false;
        });


        // this.$store.dispatch(`reconciliation/${FETCH_USER_DATA_BY_PROPERTY_TYPE}`,{
        //     property_type: 'currency'
        // }).then((response) => {
        //     if(response.content) {
        //         this.currencies = response.content.map(i => i['data_id']);
        //     }
        // });
    },

    methods: {
        fetchProperties() {
            if(this.dataSourceA && this.dataSourceB) {
                let properties = ["brand_id", "country", "currency"];
                if(this.paymentChannelListMap[this.dataSourceA.key].category === 'MARKETPLACE') {
                    properties.push("marketplace_id");
                }

                this.$store.dispatch(`reconciliation/${FETCH_USER_DATA_BY_PROPERTY_TYPE_LIST}`, {
                    property_type: properties,
                    data_sources: [this.dataSourceA.key, this.dataSourceB.key],
                    data_source_a: this.dataSourceA.key,
                    data_source_b: this.dataSourceB.key
                }).then(response => {
                    // brand_id
                    if(properties.includes("brand_id")) {
                        this.brand = [];
                        this.brandList = [];
                        if(response.content.brand_id) {
                            this.brandList = response.content.brand_id;
                        }
                    }

                    // marketplace_id
                    if(properties.includes("marketplace_id")) {
                        this.marketPlace = [];
                        this.marketPlaceList = [];
                        if(response.content.marketplace_id) {
                            this.marketPlaceList = response.content.marketplace_id;
                        }
                    }

                    // currency
                    if(properties.includes("currency")) {
                        this.currencies = [];
                        if(response.content.currency) {
                            this.currencies = response.content.currency.map(i => i['data_id'] ? i['data_id'] : i['value']);
                        }
                    }

                    // country
                    if(properties.includes("country")) {
                        this.countries = [];
                        if(response.content.country) {
                            this.countries = response.content.country.map(i => i['data_id'] ? i['data_id'] : i['value']);

                            if(this.countries.length > 0) {
                                this.country = this.countries[0];
                                this.filters.country = this.countries[0];
                                this.pageCurrency = Common.currencyByCountry(this.countries[0]);
                            }
                        }
                    }

                    this.fetchReconSummary();
                }).catch((error) => {
                    console.log(error);
                    this.loadingSankey = false;
                });
            }
        },
        dataSources() {
            if(!this.paymentChannelList) {
                return [];
            }
            let arr = [];
            for(let key of Object.keys(this.paymentChannelList)) {
                arr.push({
                    key: key,
                    display_name: this.paymentChannelListMap[key].display_name,
                    currency: this.paymentChannelListMap[key].currency,
                    msm_id: this.paymentChannelListMap[key].msm_id,
                })
            }
            return arr;
        },
        dataSources2() {
            if(!this.dataSourceA) {
                return [];
            }
            let arr = [];
            for(let key of this.paymentChannelList[this.dataSourceA.key]) {
                arr.push({
                    key: key.source_name,
                    max_date: key.max_date,
                    min_date: key.min_date,
                    msm_id: key.msm_id,
                    display_name: this.paymentChannelListMap[key.source_name].display_name
                });
            }
            return arr;
        },
        fetchBrandList() {
            this.brand = [];
            this.brandList = [];
            this.$store.dispatch(`reconciliation/${FETCH_USER_DATA_BY_PROPERTY_TYPE}`,{
                property_type: 'brand_id'
            }).then((response) => {
                if(response.content) {
                    this.brandList = response.content;
                }
            }).catch((error) => {
                console.log(error);
                this.$notify({
                    type: "error",
                    text: error.message,
                    closeOnClick: true,
                });
            });
        },
        fetchMarketPlaceList() {
            this.marketPlace = [];
            this.marketPlaceList = [];
            if(this.dataSourceA && this.paymentChannelListMap[this.dataSourceA.key].category === 'MARKETPLACE') {
                this.$store.dispatch(`reconciliation/${FETCH_USER_DATA_BY_PROPERTY_TYPE}`,{
                    property_type: 'marketplace_id',
                    source_name: this.dataSourceA.key || ""
                }).then((response) => {
                    if(response.content) {
                        this.marketPlaceList = response.content;
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$notify({
                        type: "error",
                        text: error.message,
                        closeOnClick: true,
                    });
                });
            }
        },
        setColumnsByPSPType() {
            this.fields = this.fields.map(element => {
                if(['amount_mismatch', 'fee_mismatch', 'tax_mismatch', 'quantity_mismatch'].includes(element.key)) {
                    element.thClass = "d-none";
                    element.tdClass = "d-none";
                }

                if(this.dataSourceA && this.paymentChannelListMap[this.dataSourceA.key].category !== 'MARKETPLACE' && ['sku_id', 'quantity', 'quantity_mismatch', 'marketplace_id'].includes(element.key)) {
                    element.thClass = "d-none";
                    element.tdClass = "d-none";
                }

                return element;
            });

            this.fetchProperties();
            // this.fetchBrandList();
            // this.fetchMarketPlaceList();
        },
        dateChanged() {
            const dates = {
                fromDate: this.selectedDates[0],
                toDate: this.selectedDates[1],
            }
            localStorage.setItem('recon_dashboard_dates', JSON.stringify(dates))
            this.fetchReconSummary();
        },
        summaryApiPayload() {
            const brand_id = this.brand.map((brand) => brand.data_id);
            const marketplace_id = this.marketPlace.map((marketPlace) => marketPlace.data_id);

            let fromDate = new Date(this.selectedDates[0]);
            fromDate.setHours(0, 0, 0);

            let toDate = new Date(this.selectedDates[1]);
            toDate.setHours(23, 59, 59);

            let country = [];
            if(this.country != null) {
                if(this.country == 'Empty') {
                    country.push("");
                } else {
                    country.push(this.country);
                }
            }

            let currency = [];
            if(this.currency != null) {
                if(this.currency == 'Empty') {
                    currency.push("");
                } else {
                    currency.push(this.currency);
                }
            }

            const payload = {
                from: moment(fromDate).toISOString(),
                to: moment(toDate).toISOString(),
                data_source_a: this.dataSourceA.key,
                data_source_b: this.dataSourceB.key,
                brand_id,
                marketplace_id,
                "record_type": this.transactionType == 'Refund' ? 'refund' : 'payment',
                "request_source": "portone-dev",
                msm_id: this.dataSourceB.msm_id,
                country,
                currency
            };
            return payload;
        },
        fetchReconSummary() {
            const payload = this.summaryApiPayload();
            this.loadingSankey = true;
            this.$store.dispatch(`reconAnalytics/${FETCH_RECON_SUMMARY}`, payload).then(() => {
                if(!this.series) {
                    this.createSankey();
                }
                this.fetchReconSummaryRecords();
                this.sankeyChangeData();
            })
            .finally(() => this.loadingSankey = false);
        },
        reconRecordsApiPayload(sortData) {
            const brand_id = this.brand.map((brand) => brand.data_id);
            const marketplace_id = this.marketPlace.map((marketPlace) => marketPlace.data_id);

            let status = "";
            let record_type = this.transactionType == 'Refund' ? 'refund' : 'payment';
            let mismatches = [];
            
            let node = this.reconSummary.dataFields[0];
            if(this.selectedNodes.length > 0) {
                node = this.reconSummary.dataFields.find(el => el.id === this.selectedNodes[0]);
            }

            if(node.column_category === 'mismatch') {
                mismatches = this.selectedNodes;
            }
            if(node.status) {
                status = node.status;
            }
            ({record_type} = node);

            let fromDate = new Date(this.selectedDates[0]);
            fromDate.setHours(0, 0, 0);

            let toDate = new Date(this.selectedDates[1]);
            toDate.setHours(23, 59, 59);

            let country = [];
            if(this.country != null) {
                if(this.country == 'Empty') {
                    country.push("");
                } else {
                    country.push(this.country);
                }
            }

            let currency = [];
            if(this.currency != null) {
                if(this.currency == 'Empty') {
                    currency.push("");
                } else {
                    currency.push(this.currency);
                }
            }
            
            const payload = {
                from: moment(fromDate).toISOString(),
                to: moment(toDate).toISOString(),
                data_source: node.data_source_id || "",
                record_type: record_type,
                status: status,
                page: this.currentPage,
                page_size: this.perPage,
                brand_id: brand_id,
                marketplace_id: marketplace_id,
                mismatches: mismatches,
                msm_id: this.dataSourceB.msm_id,
                node_id: node.id || "",
                country,
                currency
            }

            if(record_type === "mismatch") {
                payload.mismatches = this.mismatch_filter;
            }

            if(sortData) {
                payload.sort_key = sortData.sortBy;
                payload.sort_order = sortData.sortDesc ? 'desc' : 'asc';
            }
            return payload;
        },
        fetchReconSummaryRecords(sortData) {
            this.hidePagination = false;
            if(this.selectedNodes.length > 0) {
                let found = this.selectedNodes.find(elementNode => elementNode.id === 'unmatched_sku');
                if(found) {
                    this.hidePagination = true;
                }
            }

            const payload = this.reconRecordsApiPayload(sortData);
            this.loadingTable = true;
            this.$store.dispatch(`reconAnalytics/${FETCH_RECON_SUMMARY_TABLE_RECORDS}`, payload)
            .finally(() => this.loadingTable = false);
        },
        createSankey() {
            let root = am5.Root.new(this.$refs.sankeyrecon);

            root.setThemes([am5themes_Animated.new(root)]);

            this.series = root.container.children.push(
                am5flow.Sankey.new(root, {
                    sourceIdField: "from",
                    targetIdField: "to",
                    valueField: "weightedValue",
                    nodeWidth: 200,
                    nodePadding: 10,
                    nodeAlign: "left",
                    linkTension: 0,
                })
            );

            // Node
            this.series.nodes.nodes.template.setAll({
                draggable: false,
                toggleKey: "none",
            });

            // Node design
            this.series.nodes.rectangles.template.setAll({
                strokeWidth: 4,
                cornerRadiusTL: 6,
                cornerRadiusTR: 6,
                cornerRadiusBL: 6,
                cornerRadiusBR: 6,
                templateField: "sliceSettings",
            });

            // Connector Links
            this.series.links.template.setAll({
                fillOpacity: 0.3,
                // controlPointDistance: 0.4
            });
            // Label
            this.series.nodes.labels.template.setAll({
                fill: "#fff",
                maxWidth: 180,
                oversizedBehavior: "wrap",
            });

            this.series.nodes.setAll({
                idField: "id",
                nameField: "label",
            });
        },
        removeEvents() {
            this.series.nodes.rectangles._values.forEach((value) => {
                value.events.off("click", (ev) => {
                    this.nodeSelection(ev.target._dataItem.dataContext);
                });
            });
        },
        sankeyChangeData() {
            // set data nodes [{ id: "M", name: "Refund Mismatch", sliceSettings: { fill: "#C84C62", stroke: "#BA4056" }}]
            this.removeEvents();
            const nodeList = cloneDeep(this.reconSummary.dataFields);

            nodeList.forEach(el => {
                let value = '';
                if(this.parameterType == "Count") {
                    if(el.count != undefined || el.count != null) {
                        value = `(${el.count})`;
                    }
                    if(el.count_sku != undefined || el.count_sku != null) {
                        if(value) {
                            value = value + `\nSKUxOrder - ${el.count_sku}`;
                        } else {
                            value = `SKUxOrder - ${el.count_sku}`;
                        }
                    }
                } else {
                    if( el.id === "mismatch_quantity") {
                        value = el.value;
                    } else {
                        value = el.value.toLocaleString("en-US", {style: "currency", currency: this.pageCurrency || (this.dataSourceA ? this.dataSourceA.currency : "USD"), minimumFractionDigits: 0, maximumFractionDigits: 0});
                    }
                    if(!['mismatch_fee', 'mismatch_tax', 'mismatch_amount', 'mismatch_quantity', 'mismatch_no'].includes(el.id)) {
                        value = `(${value})`;
                    }
                }

                if(this.selectedNodes.includes(el.id)) {
                    el.sliceSettings = { fill: "#6c757d", stroke: "#000" }
                    // el.label = `[#000]${el.name}[/] \n [#000][bold](${value})[/][/]`;
                }
                el.label = `${el.name}\n[bold]${value}[/]`;

                if(['mismatch_fee', 'mismatch_tax', 'mismatch_amount', 'mismatch_quantity', 'mismatch_no'].includes(el.id) && this.parameterType !== "Count") {
                    let amountValue = el.amount_value.toLocaleString("en-US", {style: "currency", currency: this.pageCurrency || (this.dataSourceA ? this.dataSourceA.currency : "USD"), minimumFractionDigits: 0, maximumFractionDigits: 0});
                    value = `(${value})`;
                    el.label = `${el.name}\n[bold]${value}[/] \n ${el.sub_text} = ${amountValue}`;
                }
                else if(['reconciled_sale_settlements'].includes(el.id) && this.parameterType !== "Count") {
                    let settlementValue = el.value_source_b.toLocaleString("en-US", {style: "currency", currency: this.pageCurrency || (this.dataSourceA ? this.dataSourceA.currency : "USD"), minimumFractionDigits: 0, maximumFractionDigits: 0});
                    value = `${el.sub_text_1}\n${value}`;
                    settlementValue = `${el.sub_text_2}\n(${settlementValue})`;
                    el.label = `${el.name}\n[bold]\n${value}\n\n\n${settlementValue}[/]`;
                }
                else if(el.id === 'sale_transactions') {
                    el.label = `[fontSize: 10px]${this.dataSourceA.display_name}[/]\n\n\n${el.label}`;
                } else if(el.id === 'sale_settlements') {
                    el.label = `[fontSize: 10px]${this.dataSourceB.display_name}[/]\n\n\n${el.label}`;
                }

                return el;
            });

            this.series.nodes.data.setAll(nodeList);

            // set data connections [{ from: "A", to: "E", value: 4 }]
            this.series.data.setAll(this.reconSummary.dataNodes);

            // event on node click
            this.series.nodes.rectangles._values.forEach((value) => {
                value.events.on("click", (ev) => {
                    this.nodeSelection(ev.target._dataItem.dataContext);
                });
            });
        },
        nodeSelection(elementNode) {
            if(elementNode.column_category === "mismatch") {
                if(this.selectedNodes.includes(elementNode.id)) {
                    this.selectedNodes = this.selectedNodes.filter((node) => node !== elementNode.id);
                    this.selectedNodeNames = this.selectedNodeNames.filter((node) => node !== elementNode.name);

                    if(elementNode.record_type in this.mismatch_filter) {
                        this.mismatch_filter[elementNode.record_type] = this.mismatch_filter[elementNode.record_type].filter((node) => node !== elementNode.id);
                    }
                } else {
                    if(this.column_category === "mismatch") {
                        this.selectedNodes.push(elementNode.id);
                        this.selectedNodeNames.push(elementNode.name);
                    } else {
                        this.selectedNodes = [elementNode.id];
                        this.selectedNodeNames = [elementNode.name];
                    }

                    if(elementNode.record_type in this.mismatch_filter) {
                        this.mismatch_filter[elementNode.record_type].push(elementNode.id)
                    }
                }
            } else {
                if(this.selectedNodes.includes(elementNode.id)) {
                    this.selectedNodes = [];
                    this.selectedNodeNames = [];
                } else {
                    this.selectedNodes = [elementNode.id];
                    this.selectedNodeNames = [elementNode.name];
                }

                this.mismatch_filter = {
                    "transaction": [],
                    "refund": []
                };
            }

            let showReconStatus = true;
            if(this.selectedNodes.length == 0 || this.selectedNodes.includes("sale_transactions") || this.selectedNodes.includes("sale_settlements")) {
                showReconStatus = false;
            }

            // (elementNode.column_category === "mismatch" && this.column_category !== "mismatch") || (elementNode.column_category !== "mismatch" && this.column_category === "mismatch")
            if(elementNode.column_category !== this.column_category) {
                this.fields = this.fields.map(element => {
                    if(['amount_mismatch', 'fee_mismatch', 'tax_mismatch', 'quantity_mismatch'].includes(element.key)) {
                        if(elementNode.column_category === "mismatch") {
                            element.thClass = "";
                            element.tdClass = "";
                        } else {
                            element.thClass = "d-none";
                            element.tdClass = "d-none";
                        }
                    }

                    if(this.dataSourceA && this.paymentChannelListMap[this.dataSourceA.key].category !== 'MARKETPLACE' && ['sku_id', 'quantity', 'quantity_mismatch', 'marketplace_id'].includes(element.key)) {
                        element.thClass = "d-none";
                        element.tdClass = "d-none";
                    }

                    if(element.key === 'status') {
                        if(showReconStatus) {
                            element.thClass = "";
                            element.tdClass = "";
                        } else {
                            element.thClass = "d-none";
                            element.tdClass = "d-none";
                        }
                    }
                    return element;
                });
            }

            this.fields.map((element, idx) => {
                if(element.key === 'raw_status') {
                    if(this.selectedNodes.length == 0 || ["sale_transactions", "unreconciled_sale_transactions"].includes(this.selectedNodes[0])) {
                        this.fields[idx].label = "Order Status(DS1)";
                    } else if(["sale_settlements", "unreconciled_sale_settlements"].includes(this.selectedNodes[0])) {
                        this.fields[idx].label = "Order Status(DS2)";
                    } else if(this.selectedNodes[0] == "unmatched_sku"){
                        this.fields[idx].label = "Order Status(DS1/DS2)";
                    } else {
                        this.fields[idx].label = "Order Status(DS1)";
                    }
                }

                if(element.key === 'raw_status_b') {
                    if(this.selectedNodes.length > 0 && ["mismatch_fee", "mismatch_no", "mismatch_tax", "mismatch_amount", "mismatch_quantity", "reconciled_sale_settlements", "matched_sku"].includes(this.selectedNodes[0])) {
                        this.fields[idx].thClass = "";
                        this.fields[idx].tdClass = "";
                    } else {
                        this.fields[idx].thClass = "d-none";
                        this.fields[idx].tdClass = "d-none";
                    }
                }

                if(element.key === 'source_display_name') {
                    if(this.selectedNodes.length > 0 && this.selectedNodes[0] === "unmatched_sku") {
                        this.fields[idx].thClass = "";
                        this.fields[idx].tdClass = "";
                    } else {
                        this.fields[idx].thClass = "d-none";
                        this.fields[idx].tdClass = "d-none";
                    }
                }
            });

            this.column_category = elementNode.column_category;
            this.status = elementNode.status || "";

            if(this.selectedNodes.length === 0) {
                this.column_category = "transaction";
            }
            this.fetchReconSummaryRecords();
            this.sankeyChangeData();
        },
        downloadData() {
            if(this.downloading) {
                return false;
            }
            let count = 0;
            if(this.selectedNodes.length > 0) {
                this.reconSummary.dataFields.map((el) => {
                    if(this.selectedNodes.includes(el.id)) {
                        if(el.count === undefined) {
                            count = el.count_sku;
                        } else {
                            count += el.count;
                        }
                    }
                });
            } else {
                count = this.reconSummary.dataFields[0].count;
            }

            if(count > 10000) {
                this.toggleDownloadModal();
            } else {
                const payload = this.reconRecordsApiPayload();
                delete payload.page_size;
                delete payload.page;

                this.downloading = true;
                this.$store.dispatch(`reconAnalytics/${DOWNLOAD_RECON_SUMMARY_TABLE_RECORDS}`, payload)
                .finally(() => this.downloading = false);
            }
        },
        toggleDownloadModal() {
            this.$root.$emit('bv::toggle::modal', 'download-modal');
        },
        sendOverEmail() {
            const payload = this.reconRecordsApiPayload();
            payload.emails = [this.$store.state.auth.currentUser.email_address];
            delete payload.page_size;
            delete payload.page;
            this.$store.dispatch(`reconAnalytics/${SEND_RECON_SUMERY_DATA_ON_EMAIL}`, payload).then(() => {
                this.$notify({
                    type: "success",
                    text: "Data sent successfully",
                    closeOnClick: true,
                });
                this.toggleDownloadModal();
            })
            .catch((error) => {
                console.log(error);
                this.$notify({
                    type: "error",
                    text: error.message,
                    closeOnClick: true,
                });
            });
        },
        // downloadSummary() {
        //     const payload = this.summaryApiPayload();
        //     this.$store.dispatch(`reconAnalytics/${EXPORT_RECON_SUMMARY}`, payload);
        // },
        countryChanged(value) {
            this.filters.country = value;
        },
        currencyChanged(value) {
            this.filters.currency = value;
        },
        toggleFilter() {
            this.filters = {
                country: this.country,
                currency: this.currency,
                brand: this.brand,
                marketPlace: this.marketPlace,
            }
            this.$root.$emit('bv::toggle::collapse', 'filter-collapse');
        },
        resetAdvanceFilters() {
            this.country = this.countries.length > 0 ? this.countries[0] : null;
            this.currency = null;
            this.brand = [];
            this.marketPlace = [];
            this.filters = {
                country: this.country,
                currency: null,
                brand: [],
                marketPlace: [],
            }
            this.pageCurrency = this.country ? Common.currencyByCountry(this.country) : this.dataSourceA.currency;
            this.fetchReconSummary();
        },
        dataSourceAChanged() {
            this.selectedNodes = [];
            this.selectedNodeNames = [];
            let dataSource = this.dataSources2();

            let found = dataSource.find(el => el.key === this.dataSourceB.key);
            if(!found) {
                if(dataSource.length > 0) {
                    this.dataSourceB = dataSource[0];
                } else {
                    this.dataSourceB = null;
                }
            } else {
                this.dataSourceB = found;
            }

            this.column_category = "transaction";
            if(this.dataSourceB) {
                this.dataSourceBChanged(this.dataSourceB);
            }
        },
        dataSourceBChanged(value) {
            this.loadingSankey = true;
            this.selectedNodes = [];
            this.selectedNodeNames = [];
            this.column_category = "transaction";
            console.log(value);
            // let dates = [this.selectedDates[0], this.selectedDates[1]];
            // if(!value.min_date.startsWith('0')) {
            //     dates[0] = new Date(value.min_date);
            // }
            // if(!value.max_date.startsWith('0')) {
            //     dates[1] = new Date(value.max_date);
            // }
            // this.selectedDates = dates;
            this.setColumnsByPSPType();
        },
        applyFilter() {
            this.country = this.filters.country;
            this.currency = this.filters.currency;
            this.brand = this.filters.brand;
            this.marketPlace = this.filters.marketPlace;
            this.pageCurrency = this.country ? Common.currencyByCountry(this.country) : this.dataSourceA.currency;
            this.fetchReconSummary();
        }
    },
    beforeDestroy() {
        if(this.series) {
            this.removeEvents();
            this.series.dispose();
            this.series = null;
        }
    }
};
</script>

<template>
    <Layout>
        <div class="menu-content mb-1">
            <div class="d-flex" style="gap: 8px;">
                <multiselect
                    :disabled="loadingSankey"
                    v-model="dataSourceA"
                    :options="dataSources()"
                    @input="dataSourceAChanged"
                    style="min-width: 230px;"
                    :allow-empty="false"
                    track-by="key"
                    label="display_name"

                    :placeholder="$t('menuitems.recon.list.data_source')"
                ></multiselect>
                <multiselect
                    :disabled="loadingSankey"
                    v-model="dataSourceB"
                    :options="dataSources2()"
                    @input="dataSourceBChanged"
                    style="min-width: 230px;"
                    :allow-empty="false"
                    track-by="key"
                    label="display_name"
                    :placeholder="$t('menuitems.recon.list.data_source')"
                ></multiselect>
            </div>

            <div class="d-flex" style="gap: 8px;">
                <date-picker
                    type="date"
                    format="DD MMM, YYYY"
                    v-model="selectedDates"
                    range
                    :clearable="false"
                    name="startdate"
                    prefix-class="xmx"
                    :disabled="loadingSankey"
                    @change="dateChanged"
                >
                    <i slot="icon-calendar">
                        <img src="@/assets/images/calendar.png" alt="Filter">
                    </i>
                </date-picker>
    
                <multiselect
                    v-model="parameterType"
                    :options="['Amount', 'Count']"
                    @input="sankeyChangeData"
                    style="width: 110px;"
                ></multiselect>
                <b-btn variant="white" :disabled="loadingSankey" v-if="countries.length !== 0 || marketPlaceList.length !== 0 || brandList.length !== 0 || currencies.length !== 0" style="min-width: fit-content; line-height: 20px; border: 1px solid #000; gap: 8px; border-radius: 12px;" class="px-3 d-flex" @click="toggleFilter">
                    <img height="16px" class="my-auto" src="@/assets/images/filter.svg" alt="Filter"><span class="my-auto">{{ $t('common.filters') }}</span>
                    <span class="rounded-circle text-center" v-show="filtersCount > 0" style="height: 16px; width: 16px; font-size: 10px; padding-top: 2px; line-height: 12px; background: #FC6B2D; color: #fff; margin-left: 75px; position: absolute; margin-top: -11px;">{{ filtersCount }}</span>
                </b-btn>
                <b-dropdown class="show_details" variant="white button-border h-100" right>
                    <template v-slot:button-content>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g opacity="0.5">
                                <path d="M8.33398 15.8333C8.33398 16.75 9.08398 17.5 10.0007 17.5C10.9173 17.5 11.6673 16.75 11.6673 15.8333C11.6673 14.9167 10.9173 14.1667 10.0007 14.1667C9.08398 14.1667 8.33398 14.9167 8.33398 15.8333ZM8.33398 4.16667C8.33398 5.08333 9.08398 5.83333 10.0007 5.83333C10.9173 5.83333 11.6673 5.08333 11.6673 4.16667C11.6673 3.25 10.9173 2.5 10.0007 2.5C9.08398 2.5 8.33398 3.25 8.33398 4.16667ZM8.33398 10C8.33398 10.9167 9.08398 11.6667 10.0007 11.6667C10.9173 11.6667 11.6673 10.9167 11.6673 10C11.6673 9.08333 10.9173 8.33333 10.0007 8.33333C9.08398 8.33333 8.33398 9.08333 8.33398 10Z" stroke="black" stroke-width="1.5"/>
                            </g>
                        </svg>
                    </template>
                    <b-dropdown-item-button @click="$router.push({name: 'Upload Files'})">Upload Files</b-dropdown-item-button>
                    <b-dropdown-item-button @click="$router.push({name: 'Configuration', query: {activeTab: 'fee'}})">Manage Fee</b-dropdown-item-button>
                    <b-dropdown-item-button @click="$router.push({name: 'Configuration', query: {activeTab: 'file'}})">Configure File</b-dropdown-item-button>
                </b-dropdown>
            </div>
        </div>
        <b-collapse id="filter-collapse" v-if="!(countries.length === 0 && marketPlaceList.length === 0 && brandList.length === 0 && currencies.length === 0)" accordion="my-accordion" style="padding: 25px;" class="common-border bg-white">
            <div class="row">
                <b-form-group
                    v-if="countries.length > 0"
                    label="Country"
                    class="col-md-4"
                >
                    <Country :countries="countries" :country="filters.country" @country-changed="countryChanged" :disabled="loadingSankey" />
                </b-form-group>
                <b-form-group
                    v-if="brandList.length > 0"
                    label="Brand"
                    label-for="psp"
                    class="col-md-4"
                >
                    <multiselect
                        v-model="filters.brand"
                        :options="brandList"
                        placeholder="Select Brand"
                        track-by="data_id"
                        label="value"
                        :disabled="loadingSankey"
                        multiple
                    ></multiselect>
                </b-form-group>
                <b-form-group
                    v-if="marketPlaceList.length > 0"
                    label="Marketplace"
                    label-for="psp"
                    class="col-md-4"
                >
                    <multiselect
                        v-model="filters.marketPlace"
                        :options="marketPlaceList"
                        placeholder="Select Marketplace"
                        track-by="data_id"
                        label="value"
                        :disabled="loadingSankey"
                        multiple
                    ></multiselect>
                </b-form-group>
            </div>

            <div class="row">
                <b-form-group
                    v-if="currencies.length > 0"
                    label="Currency"
                    class="col-md-4"
                >
                    <Currency :currencies="currencies" :currency="filters.currency" @currency-changed="currencyChanged" :disabled="loadingSankey" unselect />
                </b-form-group>
            </div>

            <div class="d-flex justify-content-between">
                <b-btn variant="link" class="p-0 text-chai my-auto" @click="resetAdvanceFilters" style="font-size: 14px; line-height: 20px;">Clear Filters</b-btn>
                <div>
                    <b-btn variant="primary" :disabled="loadingSankey" @click="toggleFilter" class="mr-2 bg-white text-dark cancel">Cancel</b-btn>
                    <b-btn variant="primary" :disabled="loadingSankey" @click="applyFilter" class="btn-padding filter-btn">Apply Filters</b-btn>
                </div>
            </div>
        </b-collapse>

        <div class="d-flex justify-content-between mt-4">
            <div>
                <h6 class="mb-0" style="color: #000; font-size: 18px; font-style: normal; font-weight: 500; line-height: 24px;">Reconciliation Results</h6>
                <p class="section-text">Below are the reconciliation results for the selected data sources. <router-link :to="{ name: 'Reconciliation' }" class="text-chai" style="text-decoration: underline !important;">Check more reconciliations</router-link></p>
            </div>

            <div>
                <div class="d-flex" style="gap: 8px;" v-if="reconSummary.lastUpdatedDate">
                    <label class="section-text my-auto">Last Updated:</label>
                    <div style="border-radius: 12px; border: 1px solid #DCDAD5; background: #FFF; padding: 12px 16px; font-size: 14px; font-weight: 500; line-height: 20px;">
                        {{ reconSummary.lastUpdatedDate | date }} <span style="color: #DCDAD5;;">|</span> {{ reconSummary.lastUpdatedDate | time }}
                    </div>
                    <!-- <DownloadBtn class="my-auto" @download-button-clicked="downloadSummary()" /> -->
                </div>
            </div>
        </div>

        <hr class="my-3" style="background: rgba(220, 218, 213, 0.30); height: 2px; border: none;">

        <div v-show="!loadingSankey && reconSummary.dataFields.length > 0" class="sankeyrecon" ref="sankeyrecon"></div>
        <div v-if="loadingSankey" class="d-flex justify-content-center sankeyrecon">
            <b-spinner small type="grow" class="my-auto"></b-spinner>
            <strong class="ml-2 my-auto">Loading...</strong>
        </div>
        <div v-if="!loadingSankey && reconSummary.dataFields.length === 0" class="d-flex justify-content-center align-items-center flex-column sankeyrecon" style="border-radius: 12px; background: rgba(220, 218, 213, 0.30);">
            <svg xmlns="http://www.w3.org/2000/svg" width="98" height="98" viewBox="0 0 98 98" fill="none">
                <ellipse cx="49" cy="95.0601" rx="49" ry="2.94" fill="#DCDAD5"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M23.5205 24.5002C23.5205 21.2527 26.1531 18.6202 29.4005 18.6202H56.799C56.9921 18.6202 57.1841 18.6296 57.3746 18.6484V31.8064C57.3746 33.9714 59.1296 35.7264 61.2946 35.7264H73.5005V60.0959C72.5534 59.8891 71.5697 59.7802 70.5605 59.7802C62.9832 59.7802 56.8405 65.9228 56.8405 73.5002C56.8405 75.7433 57.3788 77.8606 58.3333 79.7302H29.4005C26.1531 79.7302 23.5205 77.0976 23.5205 73.8502V24.5002ZM59.5521 81.6902H29.4005C25.0706 81.6902 21.5605 78.1801 21.5605 73.8502V24.5002C21.5605 20.1702 25.0706 16.6602 29.4005 16.6602H56.799C58.8783 16.6602 60.8725 17.4862 62.3428 18.9564L73.1643 29.7779C74.6345 31.2482 75.4605 33.2424 75.4605 35.3217V35.6567L75.4608 35.7264L75.4605 60.681C80.618 62.6536 84.2805 67.6492 84.2805 73.5002C84.2805 81.0775 78.1379 87.2202 70.5605 87.2202C66.053 87.2202 62.0532 85.0465 59.5521 81.6902ZM32.6276 30.6672C33.0103 30.2845 33.6308 30.2845 34.0135 30.6672L37.4855 34.1392L40.9576 30.6672C41.3403 30.2845 41.9608 30.2845 42.3435 30.6672C42.7262 31.0499 42.7262 31.6704 42.3435 32.0531L38.8715 35.5252L42.3435 38.9972C42.7262 39.3799 42.7262 40.0004 42.3435 40.3831C41.9608 40.7658 41.3403 40.7658 40.9576 40.3831L37.4855 36.9111L34.0135 40.3831C33.6308 40.7658 33.0103 40.7658 32.6276 40.3831C32.2449 40.0004 32.2449 39.3799 32.6276 38.9972L36.0996 35.5252L32.6276 32.0531C32.2449 31.6704 32.2449 31.0499 32.6276 30.6672ZM32.3405 49.4902C32.3405 48.1371 33.4374 47.0402 34.7905 47.0402H49.4905C50.8436 47.0402 51.9405 48.1371 51.9405 49.4902C51.9405 50.8433 50.8436 51.9402 49.4905 51.9402H34.7905C33.4374 51.9402 32.3405 50.8433 32.3405 49.4902ZM34.7905 49.0002C34.5199 49.0002 34.3005 49.2195 34.3005 49.4902C34.3005 49.7608 34.5199 49.9802 34.7905 49.9802H49.4905C49.7612 49.9802 49.9805 49.7608 49.9805 49.4902C49.9805 49.2195 49.7612 49.0002 49.4905 49.0002H34.7905ZM34.7905 54.8802C33.4374 54.8802 32.3405 55.9771 32.3405 57.3302C32.3405 58.6833 33.4375 59.7802 34.7905 59.7802H62.2305C63.5836 59.7802 64.6805 58.6833 64.6805 57.3302C64.6805 55.9771 63.5836 54.8802 62.2305 54.8802H34.7905ZM34.3005 57.3302C34.3005 57.0595 34.5199 56.8402 34.7905 56.8402H62.2305C62.5012 56.8402 62.7205 57.0595 62.7205 57.3302C62.7205 57.6008 62.5012 57.8202 62.2305 57.8202H34.7905C34.5199 57.8202 34.3005 57.6008 34.3005 57.3302ZM78.4805 24.7214C77.8371 23.8081 76.6784 23.4136 75.6114 23.7447C73.9414 24.2629 73.262 26.2589 74.269 27.6883L76.4048 30.72C77.0667 31.6595 77.425 32.7793 77.4314 33.9286L77.4522 37.6543C77.4601 39.0793 78.6209 40.2285 80.046 40.2222C81.4727 40.2159 82.624 39.0539 82.617 37.6271L82.597 33.5805C82.5872 31.6034 81.9715 29.6768 80.8328 28.0604L78.4805 24.7214ZM76.1923 25.6167C76.4473 25.5375 76.7244 25.6318 76.8782 25.8502L79.2305 29.1892C80.1384 30.4779 80.6292 32.0139 80.637 33.5902L80.657 37.6368C80.6587 37.9807 80.3812 38.2607 80.0373 38.2623C79.6939 38.2638 79.4141 37.9868 79.4122 37.6433L79.3913 33.9177C79.3827 32.368 78.8996 30.8581 78.0071 29.5911L75.8713 26.5595C75.6306 26.2178 75.793 25.7406 76.1923 25.6167ZM58.8005 73.5002C58.8005 67.0053 64.0657 61.7402 70.5605 61.7402C77.0554 61.7402 82.3205 67.0053 82.3205 73.5002C82.3205 79.995 77.0554 85.2602 70.5605 85.2602C64.0657 85.2602 58.8005 79.995 58.8005 73.5002ZM68.1105 67.1302C68.1105 65.7771 69.2074 64.6802 70.5605 64.6802C71.9136 64.6802 73.0105 65.7771 73.0105 67.1302V73.0102C73.0105 74.3633 71.9136 75.4602 70.5605 75.4602C69.2074 75.4602 68.1105 74.3633 68.1105 73.0102V67.1302ZM70.5605 66.6402C70.2899 66.6402 70.0705 66.8595 70.0705 67.1302V73.0102C70.0705 73.2808 70.2899 73.5002 70.5605 73.5002C70.8312 73.5002 71.0505 73.2808 71.0505 73.0102V67.1302C71.0505 66.8595 70.8312 66.6402 70.5605 66.6402ZM70.5605 82.3202C69.2074 82.3202 68.1105 81.2233 68.1105 79.8702C68.1105 78.5171 69.2074 77.4202 70.5605 77.4202C71.9136 77.4202 73.0105 78.5171 73.0105 79.8702C73.0105 81.2233 71.9136 82.3202 70.5605 82.3202ZM70.0705 79.8702C70.0705 80.1408 70.2899 80.3602 70.5605 80.3602C70.8312 80.3602 71.0505 80.1408 71.0505 79.8702C71.0505 79.5995 70.8312 79.3802 70.5605 79.3802C70.2899 79.3802 70.0705 79.5995 70.0705 79.8702Z" fill="black" fill-opacity="0.5"/>
            </svg>
            <p class="mb-2 mt-4" style="font-size: 18px; font-style: normal; font-weight: 500;">You don’t have any data for the reconciliation process!</p>
            <p class="mb-2" style="font-size: 14px; font-style: normal; font-weight: 400; color: rgba(0, 0, 0, 0.50);">Please upload the files you want to reconcile in order to check the results.</p>
            <button
                v-if="userPermissions.includes('create-recons') || userRoles.includes('admin') || userRoles.includes('sub-admin')"
                class="btn btn-primary mt-4"
                style="height: 44px; line-height: 20px;"
                @click="$router.push({name: 'Upload Files', query: {showFileUploadmodal: true}})"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M13.6997 7.41634C16.6997 7.67467 17.9247 9.21634 17.9247 12.5913V12.6997C17.9247 16.4247 16.4331 17.9163 12.7081 17.9163H7.28307C3.55807 17.9163 2.06641 16.4247 2.06641 12.6997V12.5913C2.06641 9.24134 3.27474 7.69967 6.22474 7.42467M9.99974 12.4997V3.01634M12.7914 4.87467L9.99974 2.08301L7.20807 4.87467" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                {{ $t("views.reconciliation.add_files") }}
            </button>
        </div>

        <div v-if="!loadingSankey && reconSummary.dataFields.length > 0">
            <div class="d-flex justify-content-between flex-wrap section-header px-4 py-3 mt-4" style="gap: 10px;">
                <div>
                    <p class="section-title">{{ tableTitle }}</p>
                    <p class="section-text text-black">DS1 = {{dataSourceA.display_name}}</p>
                    <p class="section-text text-black">DS2 = {{dataSourceB.display_name}}</p>
                </div>
                <DownloadBtn class="my-auto" @download-button-clicked="downloadData" :downloading="downloading" />
            </div>

            <b-modal
                id="download-modal"
                no-close-on-backdrop
                hide-footer
                hide-header
            >
                <div class="d-flex justify-content-between mb-4" style="padding-bottom: 25px;">
                    <h5 style="font-size: 24px; font-weight: 700; line-height: 24px;letter-spacing: -0.36px;" class="text-black">File Too Large to Download</h5>
                    <img @click="toggleDownloadModal" class="modal-close my-auto" src="@/assets/images/close.svg" alt="close" />
                </div>
                <p class="mb-2 pb-1">The file is too large to download. It will be sent to your email for easier access. Would you like to send it to the email below?</p>
                <div class="d-flex mb-3" style="border-radius: 12px; border: 2px solid rgba(220, 218, 213, 0.30); padding: 10px;">
                    <div class="p-1" style="height: 34px; border-radius: 8px; border: 1px solid rgba(220, 218, 213, 0.30); background: rgba(220, 218, 213, 0.30);">
                        <img src="@/assets/images/sms.svg" alt="Email" style="height: 24px; width: 24px;">
                    </div>
                    <p class="my-auto font-14px ml-3" style="font-weight: 500; line-height: 20px;">{{ $store.state.auth.currentUser.email_address }}</p>
                </div>
                <div class="d-flex justify-content-end">
                    <b-btn variant="primary" @click="toggleDownloadModal" class="mr-2 bg-white text-dark cancel">Cancel</b-btn>
                    <b-btn variant="primary" @click="sendOverEmail" class="btn-padding filter-btn">
                        Send Over Email
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" class="ml-2">
                            <path d="M1.5 6.375C1.5 3.75 3 2.625 5.25 2.625H12.75C15 2.625 16.5 3.75 16.5 6.375V11.625C16.5 14.25 15 15.375 12.75 15.375H5.25" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12.75 6.75L10.4025 8.625C9.63 9.24 8.3625 9.24 7.59 8.625L5.25 6.75" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M1.5 12.375H6" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M1.5 9.375H3.75" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </b-btn>
                </div>
            </b-modal>

            <b-table
                class="table-custom"
                :items="tableDataFromStore"
                :fields="tableColumns"
                responsive="sm"
                sticky-header="500px"
                @sort-changed="fetchReconSummaryRecords"
                show-empty
                :empty-text="$t('common.no-records')"
                :busy="loadingTable"
                hover
            >
                <template #head(transaction_id)>
                    {{dataSourceA && paymentChannelListMap[dataSourceA.key].category === 'MARKETPLACE' ? 'Order Number' : 'Txn Ref'}}
                </template>
                <template #head(amount)="data">
                    <span v-b-tooltip.hover.top :title="column_category == 'settlement' ? 'DS2' : 'DS1'">
                        {{ $t(data.label) }} <b-icon icon="info-circle-fill"></b-icon>
                    </span>
                </template>
                <template #head(quantity)="data">
                    <span v-b-tooltip.hover.top :title="column_category == 'settlement' ? 'DS2' : 'DS1'">
                        {{ $t(data.label) }} <b-icon icon="info-circle-fill"></b-icon>
                    </span>
                </template>

                <template #head(amount_mismatch)="data">
                    <span v-b-tooltip.hover.top title="DS1 - DS2">
                        {{ $t(data.label) }} <b-icon icon="info-circle-fill"></b-icon>
                    </span>
                </template>
                <template #head(fee_mismatch)="data">
                    <span v-b-tooltip.hover.top title="DS1 - DS2">
                        {{ $t(data.label) }} <b-icon icon="info-circle-fill"></b-icon>
                    </span>
                </template>
                <template #head(quantity_mismatch)="data">
                    <span v-b-tooltip.hover.top title="DS1 - DS2">
                        {{ $t(data.label) }} <b-icon icon="info-circle-fill"></b-icon>
                    </span>
                </template>

                <template #cell()="{field, item, value}">
                    <div v-if="field.display_name">
                        <span v-if="field.data_type === 'amount'">
                            {{ (Number(item[field.parent_key][field.col_key])).toLocaleString("en-US", {style: "currency",currency: pageCurrency || (dataSourceA ? dataSourceA.currency : "USD")}) }}
                        </span>
                        <span v-else>
                            {{ item[field.parent_key][field.col_key] }}
                        </span>
                    </div>
                    <div v-else>
                        {{ value }}
                    </div>
                </template>

                <template #cell(record_created_at)="row">
                    <p class="table-date">{{ row.value | date }}</p>
                    <p class="table-time">at {{ row.value | time }}</p>
                </template>
    
                <template #cell(amount)="row">
                    {{ (row.value).toLocaleString("en-US", {style: "currency",currency: pageCurrency || (dataSourceA ? dataSourceA.currency : "USD")}) }}
                </template>

                <template #cell(sku_id)="{value}">
                    {{ value || 'NA' }}
                </template>

                <template #cell(tags)="{value}">
                    <div v-for="tag in value"
                        :class="{
                            'badge-soft-danger': tag === 'refund',
                            'badge-soft-success': tag === 'charge',
                            'badge-soft-warning': tag === 'adjustment',
                            'badge-soft-secondary': tag === 'chargeback',
                            'badge-orange': tag === 'chargeback won',
                            'badge-soft-info': tag === 'dispute_reversal',
                            'badge-purple': tag === 'refund_failure',
                            'badge-gold': tag === 'FB/IG Tax',
                            'badge-crimson-red': tag === 'exchange rate',
                        }"
                        class="mb-1 badge d-block custom-status" :key="tag"
                    >
                        {{tag}}
                    </div>
                </template>

                <template #cell(amount_mismatch)="row">
                    {{ (row.value).toLocaleString("en-US", {style: "currency",currency: pageCurrency || (dataSourceA ? dataSourceA.currency : "USD")}) }}
                </template>
    
                <template #cell(fee_mismatch)="row">
                    {{ (row.value).toLocaleString("en-US", {style: "currency",currency: pageCurrency || (dataSourceA ? dataSourceA.currency : "USD")}) }}
                </template>
    
                <template #cell(tax_mismatch)="row">
                    {{ (row.value).toLocaleString("en-US", {style: "currency",currency: pageCurrency || (dataSourceA ? dataSourceA.currency : "USD")}) }}
                </template>
    
                <template #cell(status)="{value}">
                    <div
                        class="badge custom-status"
                        style="text-transform: capitalize;"
                        :class="{
                            'badge-soft-danger': value === 'unreconciled',
                            'badge-soft-success': value === 'reconciled'
                        }"
                        >{{ value }}</div>
                </template>
    
                <template #table-busy>
                    <div class="text-center">
                        <b-spinner class="align-middle" :small="true"></b-spinner>
                    </div>
                </template>
            </b-table>
    
            <div class="d-flex justify-content-between">
                <per-page
                    v-show="!hidePagination"
                    v-model="perPage"
                    :currentPage="currentPage"
                    :totalRows="totalElementsFromStore"
                    :tableRowsCount="tableDataFromStore.length"
                    @input="fetchReconSummaryRecords"
                />
                <b-pagination
                    v-show="!hidePagination"
                    class="my-auto"
                    v-model="currentPage"
                    @input="fetchReconSummaryRecords"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :total-rows="totalElementsFromStore"
                ></b-pagination>
            </div>
        </div>
    </Layout>
</template>

<style lang="scss" scoped>
::v-deep .sankeyrecon {
    canvas:last-child {
        display: none !important;
    }
    width: 100%;
    height: 566px;
}
.menu-content {
    gap: 8px;
    flex-wrap: wrap;
}
::v-deep .xmx-input {
    padding: 13px;
    padding-left: 35px;
    height: 44px;
    border-radius: 12px;
    border: 1px solid #DCDAD5;
    background: transparent;
    font-size: 14px;
    font-weight: 500;
    color: #000;
}
::v-deep .xmx-datepicker {
    min-width: 260px;
}
::v-deep .xmx-icon-calendar {
    left: 10px;
}
.xmx-icon-calendar img{
    width: 17px;
    height: 17px;
}
::v-deep .button-border {
    border-radius: 12px !important;
    border: 1px solid #DCDAD5 !important;
    background: #FFF !important;
}
::v-deep .show_details ul{
    box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.30);
    border-radius: 12px;
    margin-top: 6px;
    padding: 12px;

}
::v-deep .show_details ul li button{
    padding: 12px;
    border-radius: 0px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;

    &:hover {
        color: #FC6B2D;
        border-radius: var(--8, 8px);
        background: rgba(220, 218, 213, 0.30);
    }
}
::v-deep .xmx-datepicker-range {
    width: 245px !important;
}
::v-deep .dropdown-item:hover {
    border-right: none !important;
}
::v-deep .table-custom .table > thead > tr {
    th:first-child, th:last-child {
        border-radius: 0;
    }

    .table-b-table-default {
        border-bottom: 1px solid #DCDAD5;
        background: #e9e7e3 !important;
        font-weight: 500;
        line-height: 20px;
    }
}
.btn.disabled, .btn:disabled:not(.filter-btn) {
    color: rgba(0, 0, 0, 0.5);
}
::v-deep .currency .dropdown-toggle {
  min-width: 270px;
}
</style>